module.exports = __webpack_public_path__ + "img/Essenza Cofani - Placeholder.842bc2cd.png";